export const SELECTORS = {
  vimeo: '.vimeo',
};

export const BREAKPOINTS = {
  isDesktop: () => window.innerWidth >= 992,
};
